module.exports = __webpack_public_path__ + "img/public/SiteIcons/supportIconOne.svg?0fdb02c4";